import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Settings } from 'src/app/interfaces/globals';
import { ScrollService } from 'src/app/services/navigation/scroll.service';

declare var SETTINGS : Settings;

interface IFooterItem {
    title : string,
    class : string,
    url? : string,
    component : string
}

@Component({
  selector: 'FooterComponent',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

    footerItems : IFooterItem[] = [];

    constructor(private _router : Router, private _scroll : ScrollService, private _routerAngular : Router) {}

    /**
     * Load initial methods.
     *
     * @memberof FooterComponent
     */
    ngOnInit() : void {
        this.setFooterItems();
    }
    
	/**
     * Navigate to component.
     *
     * @param {string} component
     * @memberof FooterComponent
     */
    goNavigation(component : string) : void {

        let isComponent : boolean = component.toLocaleLowerCase().includes("component");

        if(isComponent) {
            this._router.navigate(["list-view"]);
		    this._scroll.scrollTo(component);
        }
        else {
            this._routerAngular.navigate([component]);
        }
	}

    /**
     * Set the footer items.
     *
     * @memberof FooterComponent
     */
    setFooterItems() : void {
        this.footerItems.push(
            {
                title : 'Soluciones BRIO S.A.P.I. de C.V.',
                class : 'company-name',
                url : undefined,
                component : ''
            },{
                title : 'Aviso de privacidad',
                class : 'menu-button nav-link',
                url : SETTINGS.FOOTER.PRIVACY_NOTICE,
                component : ''
            },{
                title : 'Código de ética',
                class : 'menu-button nav-link',
                url : SETTINGS.FOOTER.ETHICS_CODE,
                component : ''
            },{
                title : 'Buzón de transparencia',
                class : 'menu-button nav-link',
                url : SETTINGS.FOOTER.TRANSPARENCY_MAILBOX,
                component : ''
            }
        )
    }
}